(function () {

  // ─── Format money (handles INR and other currencies) ──────────────────────
  function formatMoney(cents) {
    const symbol = window.Shopify?.moneyFormat || '₹{{amount}}';
    const amount = (cents / 100).toFixed(2);
    return symbol.replace('{{amount}}', parseFloat(amount).toLocaleString('en-IN'));
  }

  // ─── Update line item price in the DOM instantly ───────────────────────────
  function updateLinePrice(row, quantity, unitPrice) {
    const lineTotal = quantity * unitPrice;
    row.querySelectorAll('.cart-item__price-wrapper .price--end').forEach((el) => {
      el.textContent = formatMoney(lineTotal);
    });
  }

  // ─── Fetch cart and update subtotal everywhere ─────────────────────────────
  async function refreshCartTotals() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      // Update subtotal — covers most Dawn-based themes
      document.querySelectorAll(
        '.totals__subtotal-value, [data-cart-subtotal], .cart-subtotal__price'
      ).forEach((el) => {
        el.textContent = formatMoney(cart.total_price);
      });

      // Update cart count badge in header
      document.querySelectorAll(
        '[data-cart-count], .cart-count-bubble span, #cart-icon-bubble span'
      ).forEach((el) => {
        el.textContent = cart.item_count;
      });

    } catch (e) {
      console.error('Cart refresh error:', e);
    }
  }

  // ─── Send quantity update to Shopify ──────────────────────────────────────
  async function changeQuantity(variantId, newQty, row, unitPrice) {

    // Optimistic UI — update price instantly before API responds
    updateLinePrice(row, newQty, unitPrice);

    if (newQty === 0) {
      row.style.opacity = '0.4';
    }

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: newQty }),
      });

      if (!res.ok) throw new Error('Cart change failed');

      // Remove row if qty = 0
      if (newQty === 0) {
        row.remove();

        // Show empty cart message if no items left
        const tbody = document.querySelector('.cart-items tbody');
        if (tbody && tbody.querySelectorAll('tr.cart-item').length === 0) {
          document.querySelector('cart-items')?.classList.add('is-empty');
        }
      }

      // Refresh subtotal from server
      await refreshCartTotals();

    } catch (err) {
      console.error('Cart update failed:', err);
      // Revert optimistic UI on error
      row.style.opacity = '1';
      updateLinePrice(row, parseInt(row.querySelector('.quantity__input')?.value || 1), unitPrice);
    }
  }

  // ─── +/- button clicks ────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quantity__button');
    if (!btn) return;

    // Only handle cart page buttons (not PDP quantity inputs)
    const cartItem = btn.closest('tr.cart-item');
    if (!cartItem) return;

    const quantityInput = btn.closest('quantity-input')?.querySelector('.quantity__input');
    if (!quantityInput) return;

    const variantId = quantityInput.dataset.quantityVariantId;
    const unitPrice = parseInt(quantityInput.dataset.unitPrice, 10);
    const step      = parseInt(quantityInput.step || '1', 10);
    const min       = parseInt(quantityInput.dataset.min || '0', 10);
    const max       = quantityInput.max ? parseInt(quantityInput.max, 10) : Infinity;

    let currentQty  = parseInt(quantityInput.value, 10);

    if (btn.name === 'plus')  currentQty = Math.min(currentQty + step, max);
    if (btn.name === 'minus') currentQty = Math.max(currentQty - step, 0);

    quantityInput.value = currentQty;
    changeQuantity(variantId, currentQty, cartItem, unitPrice);
  });

  // ─── Direct input change (user types a number) ────────────────────────────
  document.addEventListener('change', function (e) {
    const input = e.target.closest('.quantity__input');
    if (!input) return;

    const cartItem = input.closest('tr.cart-item');
    if (!cartItem) return;

    const variantId = input.dataset.quantityVariantId;
    const unitPrice = parseInt(input.dataset.unitPrice, 10);
    const newQty    = Math.max(0, parseInt(input.value, 10) || 0);

    input.value = newQty;
    changeQuantity(variantId, newQty, cartItem, unitPrice);
  });

})();